<template>
  <div>
    <section
      id="hero"
      style="
        background: url(img/banner-4.png) no-repeat;
        background-size: 100% 80%;
      "
    >
      <div class="container">
        <div class="row py-5">
          <div class="col-lg-5 py-5">
            <h1 class="display-4">{{ $t("download-m2m") }}</h1>
            <!-- <p class="my-4 text-muted">
              Mouth 2 Mouth (M2M) Publicidad Boca a Boca. Es la forma más fácil
              de recibir recompensas por publicidad verbal.
            </p> -->
            <ul class="list-inline mb-0">
              <li class="list-inline-item mb-2 mb-lg-0">
                <a
                  href="https://play.google.com/store/apps/details?id=com.nextstation.mouth2mouth"
                >
                  <img
                    :src="require('@/assets/img/brand/google-play-1.png')"
                    width="200"
                  />
                </a>
              </li>
              <li class="list-inline-item">
                <img :src="require('@/assets/img/brand/1.png')" width="200" />
              </li>
            </ul>
          </div>
          <div class="col-lg-6 ml-auto">
            <div class="device-wrapper mx-auto">
              <div
                class="device shadow"
                data-device="iPhoneX"
                data-orientation="portrait"
                data-color="black"
              >
                <div class="screen">
                  <img
                    class="img-fluid"
                    :src="require('@/assets/img/brand/mobile.png')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  created() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
     window.location.assign("https://play.google.com/store/apps/details?id=com.nextstation.mouth2mouth");
    }

    // if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {

    // }
  },
};
</script>
<style scoped>
@import url("../../../assets/css/custom.css");
@import url("../../../assets/css/device-mockups.css");
@import url("../../../assets/css/style.blue.css");
</style>